import { render, staticRenderFns } from "./server_file_field.vue?vue&type=template&id=3fdef255&scoped=true&"
import script from "./server_file_field.vue?vue&type=script&lang=js&"
export * from "./server_file_field.vue?vue&type=script&lang=js&"
import style0 from "./server_file_field.vue?vue&type=style&index=0&id=3fdef255&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdef255",
  null
  
)

export default component.exports